import { DatatableColumn } from "../datatable-types";

export const resolveSectionColumnIdFromUrl = (
  urlParams: URLSearchParams,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: DatatableColumn<any>[],
): string | undefined => {
  const sectionColumnId = urlParams.get("sectionColumnId");

  if (!sectionColumnId) {
    return undefined;
  }

  const column = columns.find((column) => column.columnId === sectionColumnId);

  if (!column) {
    return undefined;
  }

  if (column.enableSectioning) {
    return sectionColumnId;
  }
};

export const encodeSectionColumnIdToUrl = (
  urlParams: URLSearchParams,
  sectionColumnId: string | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: DatatableColumn<any>[],
): URLSearchParams => {
  const updatedParams = new URLSearchParams(urlParams);

  if (sectionColumnId) {
    const column = columns.find((column) => column.columnId === sectionColumnId);

    if (!column || !column.enableSectioning) {
      console.error(`Section column ID ${sectionColumnId} is not valid`);
    } else {
      updatedParams.set("sectionColumnId", sectionColumnId);
    }
  } else {
    updatedParams.delete("sectionColumnId");
  }

  return updatedParams;
};
